module.exports = __webpack_public_path__ + "img/bg_lvyue@3x.5d189fba.png";